import { get } from '..';

const getKnowledgeCenterArticles = (articleId?: string) => get(
  `button/knowledge-center-articles${articleId ? `/${articleId}` : ''}`,
);

export default getKnowledgeCenterArticles;
